import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@material-ui/core";
import {
  AddCircleOutline,
  ArrowBackIosSharp,
  CancelOutlined,
} from "@mui/icons-material";
import { Autocomplete } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import http from "../services/httpService";
import {
  getDate,
  manualAdviceTabsPath,
  rebalance_data_path,
} from "../utils/varialbles";

// import { manualAdviceTabsPath } from "../utils/varialbles";

function RebalanceSell() {
  const history = useHistory();

  const location = useLocation();

  // console.log(location);

  const [type, setType] = useState("S");

  // console.log(type);

  const labels = [
    {
      label: !location.string ? "Mobile Number" : "",
      important: !location.string ? true : false,
      type: "text",
      name: "mobile",
      textType: "number",
    },
    type === "S"
      ? {
          label: "Sell Amount",
          important: true,
          type: "text",
          name: "sellamount",
          textType: "number",
        }
      : {
          label: "Buy Amount",
          important: true,
          type: "text",
          name: "sellamount",
          textType: "number",
        },

    {
      label: !location.string ? "Choose Country" : "",
      important: !location.string ? true : false,
      type: "select",
      name: "country",
    },
    {
      label: "Asset Name",
      important: true,
      type: "autocomplete",
      name: "assetname",
    },
    {
      label: "Asset Type",
      important: true,
      type: "text",
      name: "assettype",
    },
    {
      label: "ISIN Number",
      important: true,
      type: "text",
      name: "isin",
      textType: "number",
    },
    {
      label: "Amount",
      important: true,
      type: "text",
      name: "amount",
      textType: "number",
    },
  ];

  const [cols, setCols] = useState([
    {
      headername: "ID",
      id: "id",
    },
    {
      headername: "Stock Name",
      id: "stockname",
    },
    {
      headername: "Asset Type",
      id: "assettype",
    },
    {
      headername: "Amount",
      id: "amount",
      format: "amount",
    },
    {
      headername: "ISIN Code",
      id: "ISINCode",
    },
    {
      headername: "Country",
      id: "country",
    },
    {
      headername: "Creted",
      id: "createddt",
      format: "date",
    },
    {
      headername: "Updated",
      id: "updateddt",
      format: "date",
    },
    { id: "edit", headerName: "" },
    { id: "del", headerName: "" },
  ]);

  useEffect(() => {}, [cols, type]);

  const formobj = location.object;
  const [formObject, setFormObject] = useState({
    mobile: "",
    sellamount: "",
    country: "",
    assettype: "",
    stockname: null,
    ISINCode: "",
    amount: "",
    cust_id: "",
  });

  // console.log(
  //   location.sForm,
  //   location.bForm,
  //   location.request_id,
  //   location.mobile,
  //   location.sellamount,
  //   location.country
  // );

  const [error, setError] = useState("");
  const [showError, setShowError] = useState("");

  const numexp = /^[0-9]*$/;

  //   code for thousand seperator
  // const addCommas = (num) =>
  //   num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");
  //   code for thousand seperator //

  const handleChange = (e, item) => {
    if (formObject.mobile) {
      setVerifybtn(false);
    }
    if (formObject.country) {
      setVerifybtnReq(false);
    }

    const name = Object.keys(formObject).filter((item, index) => {
      if (item === e.target.name) {
        return item;
      }
    });
    setShowError(name[0]);

    if (item.textType === "number") {
      if (!numexp.test(e.target.value)) {
        setError("should not enter any special characters or characters");
      } else if (numexp.test(e.target.value)) {
        setError("");
      } else if (e.target.value.length > 10) {
        setError("Mobile number should not be greater than the 10 digits");
      }
    }
    setFormObject({ ...formObject, [e.target.name]: e.target.value });
  };

  const autoCompleteClickSell = () => {
    // console.log('crctvbhnjmkl');
    // http
    //     .post(`${rebalanceRequest}?mobile=${formObject.mobile}`, sendDetails)
    //     .then((res) => {
    //       if (res.data.statusCode === 0) {
    //         // setVerifybtnReq(true);
    //         // setFormObject({ ...formObject, request: res.data.Data });

    //           if (res.data.asset_data.length > 0) {
    //             setAssetNames(res.data.asset_data);
    //             setallassetNames(res.data.asset_data);
    //           } else {
    //             setStockErr("No Stocks");
    //           }

    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // alert("hi");
    let tempArr = [];
    console.log(assetNames);
    if (oldArrar) {
      console.log("oldArrar");
      assetNames.map((item, index1) => {
        var item_val = false;
        oldArrar.map((olditem, index2) => {
          // console.log(item, "item");
          // console.log(olditem, "olditem");
          if (item.ISINCode === olditem.ISINCode) {
            item_val = true;
          }
        });
        if (!item_val) {
          tempArr.push(item);
        }
        setAssetNames(tempArr);
        setFormObject({ ...formObject, stockname: "" });
      });
    }
  };

  const autoCompleteClickBuy = () => {
    // http
    //     .post(`${rebalanceRequest}?mobile=${formObject.mobile}`, sendDetails)
    //     .then((res) => {
    //       if (res.data.statusCode === 0) {
    // setVerifybtnReq(true);
    // setFormObject({ ...formObject, request: res.data.Data });
    // if (type === "B") {
    //   http
    //     .get("/assetname")
    //     .then((res) => {
    //       if (res.data.statusCode === 0) {
    //         setAssetNames(res.data.Data);

    //         setSellAmnt(true);
    //       }
    //       if (res.data.statusCode === 1) {
    //         setAssetNames([]);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }
    //   }
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
    // alert("function clicked");
    let tempArr = [];
    if (oldArrarBuy) {
      // console.log("Your In");
      assetNames.map((item, index1) => {
        var item_val = false;
        oldArrarBuy.map((olditem, index2) => {
          if (item.ISINCode === olditem.ISINCode) {
            item_val = true;
          }
        });
        if (!item_val) {
          tempArr.push(item);
        }
        setAssetNames(tempArr);
        // console.log(tempArr);
        setFormObject({ ...formObject, stockname: "" });
      });
    }
  };

  const handleChangeCompany = (e, value) => {
    setFormObject({
      ...formObject,
      stockname: value.Investment_Name,
      assettype: value.Asset_Class,
      ISINCode: value.ISINCode,
    });

    // setautoCompleteValue(value.Investment_Name);
  };

  const gotoManualadvices = () => {
    history.push({
      pathname: manualAdviceTabsPath,
      string: location.string ? location.string : "",
    });
  };

  const rebalanceRequest = "/rebalanceRequest";

  const [setCountry, SetShowCountry] = useState([]);
  const [assetNames, setAssetNames] = useState([]);
  const [allAssetNames, setallassetNames] = useState([]);
  const [veriftybtn, setVerifybtn] = useState(false);
  const [veriftybtnReq, setVerifybtnReq] = useState(false);

  const [successText, setSuccessText] = useState("");
  const [stockErr, setStockErr] = useState(false);

  const verifyNumber = () => {
    if (formObject.mobile) {
      http
        .get(`${rebalanceRequest}?mobile=${formObject.mobile}`)
        .then((res) => {
          if (res.data.statusCode === 0) {
            setVerifybtn(true);
            SetShowCountry(res.data.Data);
            setSuccessText("Mobile Number Successfully verified");
            setFormObject({ ...formObject, cust_id: res.data.cust_id });
          } else {
            SetShowCountry([]);
            setError(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setError("Please enter mobile number");
    }
  };

  const [oldArrar, setOldArray] = useState([]);

  const [oldArrarBuy, setOldArrayBuy] = useState([]);

  const sendDetails = {
    mobile: formObject["mobile"],
    amount: formObject["sellamount"],
    country: formObject["country"],
  };

  const [sellAmnt, setSellAmnt] = useState(false);

  const createReq = () => {
    if (
      formObject["mobile"] &&
      formObject["country"] &&
      formObject["sellamount"]
    ) {
      http
        .post(`${rebalanceRequest}?mobile=${formObject.mobile}`, sendDetails)
        .then((res) => {
          if (res.data.statusCode === 0) {
            setVerifybtnReq(true);
            setFormObject({ ...formObject, request: res.data.Data });
            if (type === "B") {
              http
                .get("/assetname")
                .then((res) => {
                  if (res.data.statusCode === 0) {
                    setAssetNames(res.data.Data);

                    setSellAmnt(true);
                  }
                  if (res.data.statusCode === 1) {
                    setAssetNames([]);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              if (res.data.asset_data.length > 0) {
                setAssetNames(res.data.asset_data);
                setallassetNames(res.data.asset_data);
              } else {
                setStockErr("No Stocks");
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast("please fill all the first three fields");
    }
  };

  const addtosellListform = {
    assettype: formObject["assettype"],
    ISINCode: formObject["ISINCode"],
    country: formObject["country"],
    request: location.country ? location.request_id : formObject["request"],
    amount: formObject["amount"],
    stockname: formObject["stockname"],
    cust: location.country ? location.cust_id : formObject["cust_id"],
    type: "S",
  };
  // console.log(location.cust_id);
  const addtoBuyListform = {
    assettype: formObject["assettype"],
    ISINCode: formObject["ISINCode"],
    country: formObject["country"],
    request: location.country ? location.request_id : formObject["request"],
    amount: formObject["amount"],
    stockname: formObject["stockname"],
    cust: location.country ? location.cust_id : formObject["cust_id"],
    type: "B",
  };

  const getData = () => {
    http
      .get(
        `advicerebalancerequestsbyid/${
          formObject.request || (location ? location.request_id : "")
        }/?action=${type}`
      )
      .then((res) => {
        if (res.data.statusCode === 0) {
          if (type === "S") {
            setOldArray(res.data.Data);
          } else {
            setOldArrayBuy(res.data.Data);
          }
        } else {
          setOldArray([]);
          setOldArrayBuy([]);
        }
      })
      .catch((err) => {});
  };

  const addtosellList = () => {
    // setAssetNames([]);
    setFormObject({
      ...formObject,
      assettype: "", //done
      stockname: "",
      ISINCode: "", //done
      amount: "",
    });

    http
      .post("manualrebalanceadvice", addtosellListform)
      .then((res) => {
        // console.log(res.data);
        setOldArray((oldArrar) => [...oldArrar, res.data]);

        document.getElementById("assetname").value = null;
        document.getElementById("amount").value = "";
      })
      .catch((err) => {
        console.log(err);
      });

    // setautoCompleteValue(true);
  };

  const [editAmount, setaeditAmount] = useState("");
  // console.log(editAmount);

  const editChange = (e) => {
    setaeditAmount(e.target.value);
  };

  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const [editid, setDditid] = useState("");
  const [deletingCountryISIN, setDeletingCountryISIN] = useState({});

  const editRow = (e, item) => {
    setEditOpen(true);
    setDditid(item.id);
    setaeditAmount(item.amount);
  };

  const handleClose = () => {
    setEditOpen(false);
    setDeleteOpen(false);
  };

  const updateAmount = () => {
    http
      .patch("updaterebalancemanualrequest/" + editid + "/", {
        amount: editAmount,
      })
      .then((res) => {
        toast.success("Updated Successfully");
        setEditOpen(false);
        getData();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const DeleteRow = (e, item) => {
    setDeleteOpen(true);
    setDditid(item.id);
    setDeletingCountryISIN(item.ISINCode);
  };

  const DeleteSell = () => {
    if (oldArrar) {
      // console.log(oldArrar[0], "initial");
      let assetnameToadd = oldArrar.filter(
        (asset) => asset.ISINCode === deletingCountryISIN
      );
      const getfirstassetToAdd = assetnameToadd.find(
        (asset) => asset.ISINCode === deletingCountryISIN
      );
      // console.log(getfirstassetToAdd, "getfirstassetToAdd");
      let assetnameindex = oldArrar.indexOf(getfirstassetToAdd);
      // console.log(oldArrar, "Not deleted");
      let result = oldArrar.splice(assetnameindex, 1);
      // oldArrar = result;
      // console.log(result, "deleted");

      const filteredArray = allAssetNames.filter(
        (item1) => !oldArrar.some((item2) => item1.ISINCode === item2.ISINCode)
      );

      setAssetNames(filteredArray);
    } else if (oldArrarBuy) {
      // console.log(oldArrar[0], "initial");
      let assetnameToadd = oldArrarBuy.filter(
        (asset) => asset.ISINCode === deletingCountryISIN
      );
      const getfirstassetToAdd = assetnameToadd.find(
        (asset) => asset.ISINCode === deletingCountryISIN
      );
      // console.log(getfirstassetToAdd, "getfirstassetToAdd");
      let assetnameindex = oldArrarBuy.indexOf(getfirstassetToAdd);
      // console.log(oldArrarBuy, "Not deleted");
      let result = oldArrarBuy.splice(assetnameindex, 1);
      // oldArrarBuy = result;
      // console.log(result, "deleted");

      const filteredArray = allAssetNames.filter(
        (item1) =>
          !oldArrarBuy.some((item2) => item1.ISINCode === item2.ISINCode)
      );

      setAssetNames(filteredArray);
    }
    http
      .delete("updaterebalancemanualrequest/" + editid + "/")
      .then((res) => {
        setDeleteOpen(false);
        getData();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const moveToBuy = () => {
    // document.getElementById("assetname").value = null;
    let sum = 0;
    if (oldArrar.length > 0) {
      for (var i = 0; i < oldArrar.length; i++) {
        sum += oldArrar[i].amount;
      }
    }

    if (sum > formObject.sellamount || sum < formObject.sellamount) {
      toast.error(
        "The enter amount" +
          " " +
          formObject.sellamount +
          " " +
          "is not equal to" +
          " " +
          sum
      );
    } else {
      setType("B");
      toast.success("Amount matched");
    }
  };

  const addToBuyList = () => {
    // setAssetNames([]);
    setFormObject({
      ...formObject,
      assettype: "",
      stockname: "",
      ISINCode: "",
      amount: "",
    });

    http
      .post("manualrebalanceadvice", addtoBuyListform)
      .then((res) => {
        setOldArrayBuy((oldArrarBuy) => [...oldArrarBuy, res.data]);

        document.getElementById("assetname").value = null;
        document.getElementById("amount").value = "";
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const continueOVerallDAta = () => {
    let sum = 0;
    if (oldArrarBuy.length > 0) {
      for (var i = 0; i < oldArrarBuy.length; i++) {
        sum += oldArrarBuy[i].amount;
      }
    }
    // console.log(sum);
    // console.log(formObject.amount);
    if (formObject.sellamount > sum || formObject.sellamount < sum) {
      // console.log(sum);
      toast.error(
        "The enter amount" +
          " " +
          formObject.sellamount +
          " " +
          "is not equal to" +
          " " +
          sum
      );
    } else {
      toast.success("Amount matched");
      if (location && location.country) {
        history.push({
          pathname: rebalance_data_path,
          request_id: location.request_id,
          mobile: location.mobile,
          amount: location.sellamount,
          country: location.country,
          assetNames: location.assetNames,
          cust_id: location.cust_id,
        });
      } else {
        history.push({
          pathname: rebalance_data_path,
          request_id: formObject.request,
          mobile: formObject.mobile,
          amount: formObject.sellamount,
          country: formObject.country,
          assetNames: assetNames,
          cust_id: formObject.cust_id,
        });
      }
    }
  };

  const getData2 = () => {
    if (location && location.country && location.assetNames) {
      setAssetNames(location.assetNames);
      setFormObject({
        ...formObject,
        mobile: location.mobile,
        country: location.country,
        sellamount: location.sellamount,
      });
      if (type === "S") {
        setOldArray(location.sForm);
      } else {
        setOldArrayBuy(location.bForm);
      }
    } else {
      setOldArray([]);
      setOldArrayBuy([]);
      // setAssetNames([]);
    }
  };

  useEffect(() => {
    // console.log(location, "sedrfvbhjnkml,");
    getData2();
  }, [type]);

  // console.log(assetNames);

  const sendSellProposal = () => {
    let sum = 0;
    if (oldArrar.length > 0) {
      for (var i = 0; i < oldArrar.length; i++) {
        sum += oldArrar[i].amount;
      }
    }
    // console.log(sum);
    // console.log(formObject.amount);
    if (formObject.sellamount > sum || formObject.sellamount < sum) {
      // console.log(sum);
      toast.error(
        "The enter amount" +
          " " +
          formObject.sellamount +
          " " +
          "is not equal to" +
          " " +
          sum
      );
    } else {
      toast.success("Amount matched");
      if (location && location.country) {
        history.push({
          pathname: rebalance_data_path,
          request_id: location.request_id,
          mobile: location.mobile,
          amount: location.sellamount,
          country: location.country,
          assetNames: location.assetNames,
          cust_id: location.cust_id,
        });
      } else {
        history.push({
          pathname: rebalance_data_path,
          request_id: formObject.request,
          mobile: formObject.mobile,
          amount: formObject.sellamount,
          country: formObject.country,
          assetNames: assetNames,
          cust_id: formObject.cust_id,
        });
      }
    }

    // http
    //   .get(`sendRebalanceAdvice/${formObject.request}`)
    //   .then((res) => {
    //     if (res.data.statusCode === 0) {
    //       toast.success(res.data.Data);

    //       history.push({
    //         pathname: manualAdviceTabsPath,
    //       });
    //     } else {
    //       toast.error(res.data.Data);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  console.log(location);

  return (
    <div>
      <div
        style={{
          display: "flex",
          columnGap: 20,
          flexWrap: "wrap",
          marginBottom: 30,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ height: 40 }}
          onClick={gotoManualadvices}
        >
          <ArrowBackIosSharp /> Back
        </Button>
        {type === "S" ? (
          <p style={{ fontSize: 18, fontWeight: 500, margin: "10px 0" }}>
            <b>Create Advice</b> - Re-Balancing SELL Advice
          </p>
        ) : (
          <p style={{ fontSize: 18, fontWeight: 500, margin: "10px 0" }}>
            <b>Create Advice</b> - Re-Balancing Buy Advice
          </p>
        )}
      </div>

      <div>
        {labels.map((item, index) => {
          return (
            <div className="rebalanceSell">
              <div style={{ width: "13%", margin: "5px 0", fontSize: 18 }}>
                {item.label}{" "}
                {item.important === true ? (
                  <span style={{ color: "red" }}>*</span>
                ) : (
                  ""
                )}
              </div>
              <div>
                {item.type === "text" && item.name === "mobile" ? (
                  <>
                    {!location.string && (
                      <>
                        {type === "S" ? (
                          <input
                            type="text"
                            name={item.name}
                            onChange={(e) => handleChange(e, item)}
                            value={location.country && location.mobile}
                            disabled={(type == "B" && true) || location.country}
                          />
                        ) : (
                          <input
                            type="text"
                            name={item.name}
                            onChange={(e) => handleChange(e, item)}
                            value={
                              formObject.mobile ||
                              (location.country && location.mobile)
                            }
                            disabled={type == "B" && true}
                          />
                        )}

                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginLeft: 15 }}
                          onClick={verifyNumber}
                          // disabled={veriftybtn ? true : false}
                          // disabled={veriftybtn}
                          disabled={
                            (type == "B" && true) ||
                            veriftybtn ||
                            formObject.sellamount
                          }
                        >
                          Verify Number
                        </Button>

                        <p style={{ color: "red", marginTop: 7 }}>
                          {showError === item.name ? error : error}
                        </p>
                        <p style={{ color: "green", marginTop: 7 }}>
                          {successText}
                        </p>
                      </>
                    )}
                  </>
                ) : item.type === "text" && item.name === "sellamount" ? (
                  <>
                    <input
                      type="text"
                      name={item.name}
                      onChange={(e) => handleChange(e, item)}
                      disabled={
                        (setCountry.length > 0 ? false : true) ||
                        sellAmnt ||
                        (type == "B" && true)
                      }
                      // value={location.country && location.sellamount}
                      value={location.sellamount && location.sellamount}
                    />
                    <p style={{ color: "red", marginTop: 7 }}>
                      {showError === item.name ? error : ""}
                    </p>
                  </>
                ) : item.type === "select" && item.name === "country" ? (
                  !location.string && (
                    <>
                      <select
                        name={item.name}
                        onChange={(e) => handleChange(e, item)}
                        disabled={
                          (setCountry.length > 0 && formObject.sellamount
                            ? false
                            : true) ||
                          (type == "B" && true) ||
                          formObject.stockname
                        }
                        value={location.country && location.country}
                      >
                        <option value="">
                          {location.country ? location.country : "Select"}
                        </option>
                        {setCountry &&
                          setCountry.length > 0 &&
                          setCountry.map((item) => {
                            return (
                              <option value={item.name}>{item.name}</option>
                            );
                          })}
                      </select>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: 15 }}
                        onClick={createReq}
                        // disabled={
                        //   setCountry.length > 0 && formObject.sellamount
                        //     ? false
                        //     : veriftybtn
                        //     ? false
                        //     : true
                        // }
                        // disabled={veriftybtnReq}
                        disabled={
                          (type == "B" && true) ||
                          formObject.stockname ||
                          location.country ||
                          veriftybtnReq
                        }
                      >
                        Create Request
                      </Button>
                    </>
                  )
                ) : item.type === "autocomplete" && type === "B" ? (
                  <>
                    <Autocomplete
                      id="assetname"
                      disableClearable
                      style={{ width: "258px" }}
                      size="small"
                      options={assetNames !== 0 ? assetNames : []}
                      getOptionLabel={(option) => option.Investment_Name}
                      // renderOption={(option) => option.Investment_Name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Asset Name"
                          variant="outlined"
                          onClick={autoCompleteClickBuy}
                        />
                      )}
                      onChange={(event, newValue) => {
                        handleChangeCompany(event, newValue);
                      }}
                      name={item.name}
                      disabled={
                        (assetNames.length > 0 ? false : true) ||
                        (type === "B" && false)
                      }
                    />

                    <p style={{ color: "red" }}>
                      {assetNames.length === 0 && stockErr ? error : ""}
                    </p>
                  </>
                ) : item.type === "autocomplete" ? (
                  <>
                    <Autocomplete
                      id="assetname"
                      disableClearable
                      style={{ width: "258px" }}
                      size="small"
                      options={assetNames !== 0 ? assetNames : []}
                      getOptionLabel={(option) => option.Investment_Name}
                      // renderOption={(option) => option.Investment_Name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Asset Name"
                          variant="outlined"
                          onClick={autoCompleteClickSell}
                        />
                      )}
                      onChange={(event, newValue) => {
                        handleChangeCompany(event, newValue);
                      }}
                      name={item.name}
                      disabled={
                        (assetNames.length > 0 ? false : true) ||
                        (type === "B" && false)
                      }
                    />

                    <p style={{ color: "red" }}>
                      {assetNames.length === 0 && stockErr ? error : ""}
                    </p>
                  </>
                ) : item.type === "text" &&
                  (item.name === "isin" || item.name === "assettype") ? (
                  <>
                    <input
                      id={item.name}
                      type="text"
                      name={item.name}
                      onChange={(e) => handleChange(e, item)}
                      disabled
                      value={
                        item.name === "assettype"
                          ? formObject.assettype
                          : item.name === "isin"
                          ? formObject.ISINCode
                          : ""
                      }
                    />
                    <p style={{ color: "red", marginTop: 7 }}>
                      {showError === item.name ? error : ""}
                    </p>
                  </>
                ) : item.type === "text" ? (
                  <>
                    <input
                      id={item.name}
                      type="text"
                      name={item.name}
                      onChange={(e) => handleChange(e, item)}
                      disabled={formObject.ISINCode ? false : true}
                    />
                    <p style={{ color: "red", marginTop: 7 }}>
                      {showError === item.name ? error : ""}
                    </p>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          columnGap: 20,
          justifyContent: "space-between",
        }}
      >
        <div>
          <p
            style={{
              fontWeight: "bold",
            }}
          >
            Total:
            <input
              type="text"
              // value={addCommas(removeNonNumeric(formObject.sellamount))}
              value={formObject.sellamount}
              style={{ border: 0, outline: 0 }}
              disabled
            />
            <Button
              variant="contained"
              color="primary"
              style={{ borderRadius: 50 }}
              onClick={type === "S" ? addtosellList : addToBuyList}
            >
              {type === "S" ? (
                <>
                  <AddCircleOutline /> ADD TO SELL LIST{" "}
                </>
              ) : (
                <>
                  <AddCircleOutline /> ADD TO Buy LIST{" "}
                </>
              )}
            </Button>
          </p>
        </div>
        <div>
          {type === "S" ? (
            <>
              <Button
                variant="contained"
                color="primary"
                style={{
                  borderRadius: 50,
                  display: "inline-block",
                  marginRight: 10,
                }}
                onClick={sendSellProposal}
              >
                Skip Buy
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ borderRadius: 50, display: "inline-block" }}
                onClick={moveToBuy}
              >
                MOVE TO BUY
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              color="primary"
              style={{ borderRadius: 50, display: "inline-block" }}
              onClick={continueOVerallDAta}
            >
              Continue
            </Button>
          )}
        </div>
      </div>

      {type === "S" ? (
        oldArrar.length > 0 ? (
          <TableContainer style={{ marginBottom: "15px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  {cols.map((col, index) => {
                    return (
                      <TableCell>
                        <TableSortLabel>{col.headername}</TableSortLabel>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>

              <TableBody>
                {oldArrar.map((item, index) => {
                  return (
                    <TableRow>
                      {cols.map((col, index) => {
                        const value = item[col.id];
                        return (
                          <TableCell>
                            {col.format === "date" ? (
                              getDate(value)
                            ) : col.format === "amount" ? (
                              value
                            ) : col.id === "edit" ? (
                              <Button
                                style={{
                                  borderRadius: 10,
                                  marginLeft: 10,
                                  textTransform: "math-auto",
                                }}
                                onClick={(e) => editRow(e, item)}
                                variant="contained"
                                color="primary"
                              >
                                Edit
                              </Button>
                            ) : col.id === "del" ? (
                              <Button
                                onClick={(e) => DeleteRow(e, item)}
                                variant="contained"
                                color="primary"
                              >
                                Delete
                              </Button>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      {type === "B" ? (
        oldArrarBuy.length > 0 ? (
          <TableContainer style={{ marginBottom: "15px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  {cols.map((col, index) => {
                    return (
                      <TableCell>
                        <TableSortLabel>{col.headername}</TableSortLabel>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {oldArrarBuy.map((item, index) => {
                  return (
                    <TableRow>
                      {cols.map((col, index) => {
                        const value = item[col.id];
                        return (
                          <TableCell>
                            {col.format === "date" ? (
                              getDate(value)
                            ) : col.format === "amount" ? (
                              value
                            ) : col.id === "edit" ? (
                              <Button
                                style={{
                                  borderRadius: 10,
                                  marginLeft: 10,
                                  textTransform: "math-auto",
                                }}
                                onClick={(e) => editRow(e, item)}
                                variant="contained"
                                color="primary"
                              >
                                Edit
                              </Button>
                            ) : col.id === "del" ? (
                              <Button
                                onClick={(e) => DeleteRow(e, item)}
                                variant="contained"
                                color="primary"
                              >
                                Delete
                              </Button>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          ""
        )
      ) : (
        ""
      )}

      <Dialog
        open={editOpen}
        onClose={handleClose}
        style={{ padding: "20px 10px" }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <p style={{ textAlign: "right" }}>
            <CancelOutlined
              style={{ cursor: "pointer" }}
              onClick={handleClose}
            />
          </p>
        </DialogTitle>

        <DialogContent>
          <TextField
            value={formObject.ISINCode}
            disabled
            label="ISIN Code"
            variant="outlined"
            style={{
              marginRight: 17,
              padding: 5,
            }}
          />
          <TextField
            value={editAmount}
            onChange={editChange}
            variant="outlined"
            label="amount"
            style={{ padding: 5 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={updateAmount}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteOpen} onClose={handleClose}>
        <DialogContent>Are you sure you want to delete?</DialogContent>
        <DialogActions>
          <Button onClick={DeleteSell} variant="contained" color="primary">
            Yes
          </Button>
          <Button onClick={handleClose} variant="contained" color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default RebalanceSell;
